(() => {
  if (window.ucwPdp_v2) return;
  window.ucwPdp_v2 = true;
  const { quantity: readQuantity, postCart, showError } = window.UcwPdpUtils;
  const init = (section) => {
    if (section.dataset.ucwPdpInitialized) return;
    section.dataset.ucwPdpInitialized = 'true';

  const gallery = section.querySelector('[data-uw-gallery]');
  if (gallery) {
    const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
    const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
    const prev = gallery.querySelector('[data-gallery-prev]');
    const next = gallery.querySelector('[data-gallery-next]');
    let activeIndex = 0;

    const showSlide = (index) => {
      if (!slides.length) return;
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === activeIndex);
        slide.setAttribute('aria-hidden', i === activeIndex ? 'false' : 'true');
        if (i !== activeIndex) slide.querySelectorAll('video').forEach((video) => video.pause());
      });
      thumbs.forEach((thumb, i) => { thumb.classList.toggle('is-active', i === activeIndex); thumb.setAttribute('aria-pressed', i === activeIndex ? 'true' : 'false'); });
      thumbs[activeIndex]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    };

    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showSlide(index)));
    prev?.addEventListener('click', () => showSlide(activeIndex - 1));
    next?.addEventListener('click', () => showSlide(activeIndex + 1));
  }

  const originalImageDialog = section.querySelector(
    '[data-original-image-dialog]'
  );

  const originalImageSlides = Array.from(
    section.querySelectorAll('[data-original-image-slide]')
  );

  const originalImageOpenButtons = section.querySelectorAll(
    '[data-original-image-open]'
  );

  const originalImageCloseButton = section.querySelector(
    '[data-original-image-close]'
  );

  const originalImagePreviousButton = section.querySelector(
    '[data-original-image-previous]'
  );

  const originalImageNextButton = section.querySelector(
    '[data-original-image-next]'
  );

  const originalImageCounter = section.querySelector(
    '[data-original-image-current]'
  );

  if (
    originalImageDialog &&
    originalImageDialog.parentElement !== document.body
  ) {
    document.body.appendChild(originalImageDialog);
  }

  let originalImageActiveIndex = 0;
  let originalImagePreviousFocus = null;

  const showOriginalImageSlide = (index) => {
    if (!originalImageSlides.length) return;

    originalImageActiveIndex =
      (index + originalImageSlides.length) %
      originalImageSlides.length;

    originalImageSlides.forEach((slide, slideIndex) => {
      const isActive = slideIndex === originalImageActiveIndex;

      slide.classList.toggle('is-active', isActive);
      slide.setAttribute(
        'aria-hidden',
        isActive ? 'false' : 'true'
      );
    });

    if (originalImageCounter) {
      originalImageCounter.textContent = String(
        originalImageActiveIndex + 1
      );
    }
  };

  const openOriginalImageDialog = (button) => {
    if (!originalImageDialog || !originalImageSlides.length) return;

    originalImagePreviousFocus = button;

    const requestedIndex = Number.parseInt(
      button.dataset.originalImageIndex || '0',
      10
    );

    showOriginalImageSlide(
      Number.isNaN(requestedIndex) ? 0 : requestedIndex
    );

    originalImageDialog.hidden = false;
    document.body.classList.add('ucw-v2-modal-open');

    requestAnimationFrame(() => {
      originalImageCloseButton?.focus();
    });
  };

  const closeOriginalImageDialog = () => {
    if (!originalImageDialog) return;

    originalImageDialog.hidden = true;
    document.body.classList.remove('ucw-v2-modal-open');

    if (originalImagePreviousFocus) {
      originalImagePreviousFocus.focus();
      originalImagePreviousFocus = null;
    }
  };

  originalImageOpenButtons.forEach((button) => {
    button.addEventListener('click', () => {
      openOriginalImageDialog(button);
    });
  });

  originalImageCloseButton?.addEventListener(
    'click',
    closeOriginalImageDialog
  );

  originalImagePreviousButton?.addEventListener('click', () => {
    showOriginalImageSlide(originalImageActiveIndex - 1);
  });

  originalImageNextButton?.addEventListener('click', () => {
    showOriginalImageSlide(originalImageActiveIndex + 1);
  });

  originalImageDialog?.addEventListener('click', (event) => {
    if (event.target === originalImageDialog) {
      closeOriginalImageDialog();
    }
  });

  const lifecycle = new AbortController();
  document.addEventListener('keydown', (event) => {
    if (!originalImageDialog || originalImageDialog.hidden) return;

    window.UcwPdpUtils.trapFocus(event, originalImageDialog);

    if (event.key === 'Escape') {
      event.preventDefault();
      closeOriginalImageDialog();
      return;
    }

    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      showOriginalImageSlide(originalImageActiveIndex - 1);
    }

    if (event.key === 'ArrowRight') {
      event.preventDefault();
      showOriginalImageSlide(originalImageActiveIndex + 1);
    }
  }, { signal: lifecycle.signal });
  document.addEventListener('shopify:section:unload', (event) => {
    if (!event.target.contains(section)) return;
    if (originalImageDialog && !originalImageDialog.hidden) closeOriginalImageDialog();
    originalImageDialog?.remove();
    lifecycle.abort();
  }, { signal: lifecycle.signal });

  const minus = section.querySelector('[data-qty-minus]');
  const plus = section.querySelector('[data-qty-plus]');
  const qty = section.querySelector('[data-ucw-quantity]');
  const freeShipping = section.querySelector('[data-uw-free-shipping]');

  const updateFreeShipping = () => {
    if (!freeShipping || !qty) return;

    const quantity = readQuantity(qty.value);

    const unitPrice = parseInt(
      freeShipping.dataset.unitPrice || '0',
      10
    );

    const threshold = parseInt(
      freeShipping.dataset.freeShippingThreshold || '5000',
      10
    );

    const totalPrice = unitPrice * quantity;

    freeShipping.hidden = totalPrice < threshold;
  };

  const stockBlock = section.querySelector('[data-uw-stock]');
  const stockAvailable = section.querySelector('[data-uw-stock-available]');
  const stockInsufficient = section.querySelector('[data-uw-stock-insufficient]');
  const stockOut = section.querySelector('[data-uw-stock-out]');

  const updateStockStatus = () => {
    if (!stockBlock || !qty) return;

    const selectedQuantity = readQuantity(qty.value);

    const stockQuantity = Math.max(
      0,
      parseInt(stockBlock.dataset.stockQuantity || '0', 10)
    );

    const stockManaged =
      stockBlock.dataset.stockManaged === 'true';

    
    if (!stockManaged) {
      const available = stockBlock.dataset.variantAvailable !== 'false';
      if (stockAvailable) stockAvailable.hidden = !available;
      if (stockInsufficient) stockInsufficient.hidden = true;
      if (stockOut) stockOut.hidden = available;
      return;
    }

    
    if (stockQuantity <= 0) {
      if (stockAvailable) stockAvailable.hidden = true;
      if (stockInsufficient) stockInsufficient.hidden = true;
      if (stockOut) stockOut.hidden = false;
      return;
    }

    
    if (selectedQuantity <= stockQuantity) {
      if (stockAvailable) stockAvailable.hidden = false;
      if (stockInsufficient) stockInsufficient.hidden = true;
      if (stockOut) stockOut.hidden = true;
      return;
    }

    
    if (stockAvailable) stockAvailable.hidden = true;
    if (stockInsufficient) stockInsufficient.hidden = false;
    if (stockOut) stockOut.hidden = true;
  };

  if (minus && plus && qty) {
    minus.addEventListener('click', () => {
      qty.value = Math.max(
        1,
        readQuantity(qty.value) - 1
      );

      qty.dispatchEvent(
        new Event('change', { bubbles: true })
      );
    });

    plus.addEventListener('click', () => {
      qty.value =
        readQuantity(qty.value) + 1;

      qty.dispatchEvent(
        new Event('change', { bubbles: true })
      );
    });

    qty.addEventListener('input', () => {
      updateStockStatus();
      updateFreeShipping();
    });

    qty.addEventListener('change', () => {
      updateStockStatus();
      updateFreeShipping();
    });

    updateStockStatus();
    updateFreeShipping();
  }

  const productForm = section.querySelector('.ucw-v2-product-form');
  const addButton = section.querySelector('[data-uw-add]');
  const paperUpsell = section.querySelector('[data-paper-upsell]');

  if (productForm && addButton) {
    productForm.dataset.ucwPdpForm = 'true';
    let submitting = false;
    const submitProduct = async (event) => {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      if (submitting || addButton.disabled) return;
      const variantId = Number(productForm.querySelector('[data-uw-variant-id]')?.value);
      const input = productForm.querySelector('[name="quantity"]');
      const amount = readQuantity(input?.value);
      if (!variantId) return;
      if (input) {
        input.value = amount;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      const extraItems = [];
      const paperVariant = Number(paperUpsell?.dataset.paperVariantId);
      if (paperUpsell?.querySelector('[data-paper-enabled]')?.checked && paperVariant) {
        extraItems.push({ id: paperVariant, quantity: 1, properties: { '_Mee besteld bij': section.dataset.productTitle } });
      }
      submitting = true;
      addButton.disabled = true;
      addButton.setAttribute('aria-busy', 'true');
      addButton.classList.add('is-loading');
      showError(productForm, '');
      try {
        const mainItems = await window.UcwPdpBundle.items(section, variantId, amount);
        await postCart('add', { items: [...mainItems, ...extraItems] });
        document.dispatchEvent(new CustomEvent('ucw:cart-added', { detail: { productTitle: section.dataset.productTitle } }));
      } catch (error) {
        showError(productForm, error.message);
      } finally {
        submitting = false;
        addButton.disabled = false;
        addButton.removeAttribute('aria-busy');
        addButton.classList.remove('is-loading');
      }
    };
    addButton.addEventListener('click', submitProduct, true);
    productForm.addEventListener('submit', submitProduct, true);
  }

  section.querySelectorAll('[data-related-minus]').forEach((button) => {
    button.addEventListener('click', () => {
      const input = section.querySelector(`[data-related-qty="${button.dataset.relatedMinus}"]`);
      if (input) input.value = Math.max(1, readQuantity(input.value) - 1);
    });
  });

  section.querySelectorAll('[data-related-plus]').forEach((button) => {
    button.addEventListener('click', () => {
      const input = section.querySelector(`[data-related-qty="${button.dataset.relatedPlus}"]`);
      if (input) input.value = readQuantity(input.value) + 1;
    });
  });

  section.querySelectorAll('[data-related-add]').forEach((button) => {
    button.addEventListener('click', async () => {
      if (button.disabled) return;
      const variantId = button.dataset.relatedAdd;
      const input = section.querySelector(`[data-related-qty="${variantId}"]`);
      const amount = readQuantity(input?.value);
      if (input) input.value = amount;
      const card = button.closest('article') || button.parentElement;
      const oldText = button.innerHTML;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      showError(card, '');
      try {
        await postCart('add', { items: [{ id: Number(variantId), quantity: amount }] });
        button.textContent = '✓';
        document.dispatchEvent(new CustomEvent('ucw:cart-added', { detail: { productTitle: section.dataset.productTitle } }));
      } catch (error) {
        showError(card, error.message);
      } finally {
        button.removeAttribute('aria-busy');
        setTimeout(() => { button.disabled = false; button.innerHTML = oldText; }, 1200);
      }
    });
  });

  const relatedSlider = section.querySelector('[data-related-slider]');
  if (relatedSlider) {
    const track = relatedSlider.querySelector('[data-related-track]');
    const prev = relatedSlider.querySelector('[data-related-prev]');
    const next = relatedSlider.querySelector('[data-related-next]');

    const scrollRelated = (direction) => {
      if (!track) return;
      const card = track.querySelector('[data-related-card]');
      const amount = card ? card.offsetWidth + 12 : 220;
      track.scrollBy({ left: direction * amount, behavior: 'smooth' });
    };

    prev?.addEventListener('click', () => scrollRelated(-1));
    next?.addEventListener('click', () => scrollRelated(1));
  }

  const volumeButtons = section.querySelectorAll('[data-volume-qty]');
  const livePrice = section.querySelector('[data-uw-live-price]');

  const formatMoney = (cents) => {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, section.dataset.moneyFormat);
    }
    return new Intl.NumberFormat('nl-NL', {
      style: 'currency',
      currency: section.dataset.currency
    }).format(cents / 100);
  };

  if (volumeButtons.length && qty) {
    const getFactorByQty = (quantity) => {
      let factor = 1;
      volumeButtons.forEach((button) => {
        const buttonQty = parseInt(button.dataset.volumeQty, 10);
        const buttonFactor = parseFloat(button.dataset.volumeFactor || '1');
        if (quantity >= buttonQty) factor = buttonFactor;
      });
      return factor;
    };

    const updateVolumeUi = () => {
      const currentQty = readQuantity(qty.value);
      const factor = getFactorByQty(currentQty);
      let activeButton = null;

      volumeButtons.forEach((button) => {
        const buttonQty = parseInt(button.dataset.volumeQty, 10);
        button.classList.remove('is-active');
        if (currentQty >= buttonQty) activeButton = button;
      });

      activeButton?.classList.add('is-active');

      if (livePrice) {
        const basePrice = parseInt(livePrice.dataset.basePrice, 10);
        livePrice.textContent = formatMoney(Math.round(basePrice * factor));
      }
    };

    volumeButtons.forEach((button) => {
      button.addEventListener('click', () => {
        qty.value = button.dataset.volumeQty;
        qty.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    qty.addEventListener('input', updateVolumeUi);
    qty.addEventListener('change', updateVolumeUi);
    updateVolumeUi();
  }

  section.querySelectorAll('[data-scroll-to-saving]').forEach((button) => {
    button.addEventListener('click', () => {
      document.querySelector('#besparing')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  const deliveryBlock = section.querySelector('[data-uw-stock-delivery]');
  const deliveryDate = deliveryBlock?.querySelector('[data-uw-delivery-date]');
  if (deliveryDate) deliveryDate.textContent = window.UcwPdpUtils.delivery().text;

  };
  const scan = (root) => root.querySelectorAll('[data-ucw-pdp-mode="v2"]').forEach(init);
  scan(document);
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
